import Swal from "sweetalert2";

function buildVendorUploadSummary(payload) {
  const processedRows = payload?.processed_rows || 0;

  const duplicateVendorCodes =
    payload?.duplicate_vendor_codes || [];

  const duplicateGSTMappings =
    payload?.duplicate_gst_vendor_mapping || [];

  const hasWarnings =
    duplicateVendorCodes.length > 0 ||
    duplicateGSTMappings.length > 0;

  let html = `
    <div style="text-align:left">

      <p style="margin-bottom:16px;font-size:15px;">
        <strong>Processed Records:</strong>
        ${processedRows}
      </p>
  `;

  // -------------------------------------------------
  // Duplicate Vendor Codes
  // -------------------------------------------------

  if (duplicateVendorCodes.length) {

    html += `
      <h4 style="margin-bottom:8px;color:#b45309;">
        Duplicate Vendor Codes
      </h4>

      <table style="
        width:100%;
        border-collapse:collapse;
        margin-bottom:20px;
      ">

        <thead>

          <tr style="background:#f7f7f7">

            <th style="border:1px solid #ddd;padding:8px;">
              Vendor Code
            </th>

            <th style="border:1px solid #ddd;padding:8px;">
              Occurrences
            </th>

          </tr>

        </thead>

        <tbody>
    `;

    duplicateVendorCodes
      .slice(0, 20)
      .forEach(item => {

        html += `
          <tr>

            <td style="border:1px solid #ddd;padding:8px;">
              ${item.VendorCode}
            </td>

            <td style="
                border:1px solid #ddd;
                padding:8px;
                text-align:center;
            ">
              ${item.Count}
            </td>

          </tr>
        `;
      });

    if (duplicateVendorCodes.length > 20) {

      html += `
        <tr>

          <td colspan="2"
              style="padding:8px;text-align:center;font-style:italic;">

            ...and ${duplicateVendorCodes.length - 20} more

          </td>

        </tr>
      `;
    }

    html += `
        </tbody>

      </table>
    `;
  }

  // -------------------------------------------------
  // GST Linked to Multiple Vendor Codes
  // -------------------------------------------------

  if (duplicateGSTMappings.length) {

    html += `
      <h4 style="margin-bottom:8px;color:#b45309;">
        GST Linked to Multiple Vendor Codes
      </h4>

      <table style="
        width:100%;
        border-collapse:collapse;
      ">

        <thead>

          <tr style="background:#f7f7f7">

            <th style="border:1px solid #ddd;padding:8px;">
              GST Number
            </th>

            <th style="border:1px solid #ddd;padding:8px;">
              Vendor Codes
            </th>

          </tr>

        </thead>

        <tbody>
    `;

    duplicateGSTMappings
      .slice(0, 20)
      .forEach(item => {

        html += `
          <tr>

            <td style="border:1px solid #ddd;padding:8px;">
              ${item.GSTNo}
            </td>

            <td style="border:1px solid #ddd;padding:8px;">
              ${item.VendorCodes.join(", ")}
            </td>

          </tr>
        `;
      });

    if (duplicateGSTMappings.length > 20) {

      html += `
        <tr>

          <td colspan="2"
              style="padding:8px;text-align:center;font-style:italic;">

            ...and ${duplicateGSTMappings.length - 20} more

          </td>

        </tr>
      `;
    }

    html += `
        </tbody>

      </table>
    `;
  }

  html += "</div>";

  return {
    html,
    hasWarnings,
  };
}

export async function showVendorUploadSummary(payload) {

  const {
    html,
    hasWarnings,
  } = buildVendorUploadSummary(payload);

  await Swal.fire({
    icon: hasWarnings ? "warning" : "success",
    title: "Vendor Master Upload Summary",
    html,
    width: "850px",
    confirmButtonText: "OK",
  });

}